<template>
	<div class="icon-chevron">
		<svg
			width="16.000000"
			height="16.000000"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip103_1327">
					<rect
						id="Icon / Pagination / Prev"
						width="16.000000"
						height="16.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<rect
				id="Icon / Pagination / Prev"
				width="16.000000"
				height="16.000000"
				fill="#FFFFFF"
				fill-opacity="0"
			/>
			<g clip-path="url(#clip103_1327)">
				<path
					id="Vector"
					d="M10.06 12L11 11.06L7.94 8L11 4.93L10.06 4L6.06 8L10.06 12Z"
					fill="#333333"
					fill-opacity="1.000000"
					fill-rule="nonzero"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconChevron extends Vue {}
</script>

<style scoped lang="scss">
.icon-chevron {
	display: flex;
}
</style>
